import React from 'react'

import { useCookies } from 'react-cookie'
import { useRouter } from 'next/router'

import { store } from 'redux/store'

import LocalStorageService from 'services/localStorage.service'

import Modal from 'components/elements/Modal'
import NewDeckForm from 'components/misc/NewDeckModal/NewDeckForm'
import PhatButton from 'components/formElements/PhatButton'

import styles from './sandboxMessage.module.scss'
import Icon from 'components/elements/Icon'

const SandboxMessage = () => {
  const router = useRouter()

  const [open, setOpen] = React.useState(false)
  const [{ tbId: userId }] = useCookies(['tbId'])

  const handleRedirectToLogin = () => {
    const deck = store.getState().deck
    const deckAsString = JSON.stringify(deck)

    LocalStorageService.set('sandboxDeck', deckAsString)

    router.push(`/login?redirectTo=${encodeURIComponent(router.asPath)}`)
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.message}>
            <Icon name="flask" />
            <span>
              You have full use of the deck editor! However, as long as you remain in sandbox mode, you will be unable
              to save your changes.
            </span>
          </div>

          {!userId && <PhatButton onClick={handleRedirectToLogin}>To save this as a new deck, login here</PhatButton>}
          {userId && <PhatButton onClick={() => setOpen(true)}>To save this as a new deck, click here</PhatButton>}
        </div>
      </div>

      <Modal
        closeButton
        open={open}
        triggerClassName={styles.button}
        modalClassName={styles.modal}
        onClose={() => setOpen(false)}>
        <NewDeckForm createDeckWithCards />
      </Modal>
    </>
  )
}

export default SandboxMessage
